export default __webpack_public_path__ + "static/media/boreal.e463e377.jpg";